import React from "react";
import { Inbox } from "lucide-react";

export const EmptyState = ({ title = "Content coming soon", description, icon: Icon = Inbox }) => (
  <div
    data-testid="empty-state"
    className="flex flex-col items-center justify-center border border-dashed border-border bg-secondary/40 px-6 py-20 text-center"
  >
    <span className="flex h-14 w-14 items-center justify-center rounded-sm bg-navy text-brand-orange">
      <Icon className="h-6 w-6" />
    </span>
    <h3 className="mt-6 font-display text-xl font-semibold text-navy">{title}</h3>
    {description && <p className="mt-2 max-w-md text-sm text-muted-foreground">{description}</p>}
  </div>
);

export default EmptyState;
